module.exports = __webpack_public_path__ + "img/ski.55047220.svg";